import { createAction, handleActions } from 'redux-actions'

const setScrollPosition = createAction('SCREENS/PLANNER/SET_SCROLL_POSITION')
const resetScrollPosition = createAction('SCREENS/PLANNER/RESET_SCROLL_POSITION')

const defaultState = {
  scrollTop: 0,
  scrollLeft: 0,
}

const reducer = handleActions(
  {
    [setScrollPosition]: (state, action) => action.payload,
    [resetScrollPosition]: () => defaultState,
  },
  defaultState,
)

export { setScrollPosition, resetScrollPosition, reducer }
